<template>
  <div class="view view-perfil">
    <top-bar v-if="isPortalReady" />
    <div class="site-content">
        <div class="container">
            <div class="row">
                <aside class="col-md-4 col-lg-3">
                    <div class="perfil-sidebar">
                        <div class="perfil-photo-uploader">
                            <perfil-picture-uploader
                                :prefill="userFoto ? userFoto : ''"
                                @updateUserPhoto="updatePhoto" />
                        </div>
                        <!--<img class="perfil-sidebar-photo"
                            :src="this.user.foto == '' ? require(`@/assets/images/default-user-icon.svg`) : this.user.foto" alt="">-->

                        <ul class="perfil-sidebar-list">
                            <li class="perfil-sidebar-list-current"
                                @click="toggleSidebarMenu">
                                {{ tabs.find(t=> t.name == activeTab).title }}
                            </li>
                            <li v-for="(tab, i) in tabs"
                                :key="i"
                                :class="activeTab == tab.name ? 'perfil-sidebar-list-active' : ''">
                                <button class="btn btn-black btn-borderless"
                                style="text-align: left;"
                                    @click="setActiveTab(tab.name)">
                                    {{ tab.title }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </aside>
                <section class="col-md-8 col-lg-9">
                    <div class="relative">
                        <div :class="'perfil-tab ' + (activeTab == 'perfil' ? 'perfil-tab-active' : '')">
                            <h1>Mi perfil</h1>
                            <perfil-form
                                :country-slug="'CL'" />
                        </div>
                        <div :class="'perfil-tab ' + (activeTab == 'compras' ? 'perfil-tab-active' : '')">
                            <h1>Mis compras</h1>
                            <compras-table
                                :compras="user.mis_compras" :compras_regaladas="user.mis_compras_regaladas"  :tipo_compras="'compras'" />
                        </div>
                        <div :class="'perfil-tab ' + (activeTab == 'moviles' ? 'perfil-tab-active' : '')">
                            <h1>Mis suscripciones móviles</h1>
                            <compras-table
                                :compras="user.mis_compras_moviles" :tipo_compras="'moviles'" />
                        </div>
                        <div :class="'perfil-tab ' + (activeTab == 'pendientes' ? 'perfil-tab-active' : '')">
                            <h1>Mis compras pendientes</h1>
                            <compras-table
                                :compras="user.mis_compras_pendientes" :tipo_compras="'pendientes'" />
                        </div>
                        <div :class="'perfil-tab ' + (activeTab == 'regalos' ? 'perfil-tab-active' : '')">
                            <h1>Mis regalos</h1>
                            <compras-table
                                :compras="user.mis_regalos" :tipo_compras="'regalos'" />
                        </div>
                       <div :class="'perfil-tab ' + (activeTab == 'referidos' ? 'perfil-tab-active' : '')">
                            <h1>Mis referidos</h1>
                            <referidos
                                :referidos="user.referidos" />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>

    <site-footer v-if="isPortalReady" :verFooter="true"/>
  </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import TopBar from "../components/TopBar";
import SiteFooter from "../components/SiteFooter";
import PerfilForm from "../components/PerfilForm";
import ComprasTable from "../components/ComprasTable";
import Referidos from "../components/Referidos";
import PerfilPictureUploader from "../components/PerfilPictureUploader";
import { format, toDate } from "date-fns";
import { es } from "date-fns/esm/locale";
import numeral from "numeral";
import "numeral/locales";

export default {
	name: "perfil",
	components: {
		TopBar,
		SiteFooter,
		PerfilForm,
		ComprasTable,
		Referidos,
        PerfilPictureUploader
	},
	inject: ["$cloudinary"],
	data() {
		return {
			tabs: [
				{
					name: "perfil",
					title: "Mi perfil"
				},
				{
					name: "compras",
					title: "Mis compras"
				},
				{
					name: "moviles",
					title: "Mis suscripciones moviles"
				},
				{
					name: "pendientes",
					title: "Mis compras pendientes"
				},
				{
					name: "regalos",
					title: "Mis regalos"
                }/*,
				{
					name: "referidos",
					title: "Mis Referidos (Crédito : "+this.formatCurrency(this.credito)+")"
				}*/
			],
			activeTab: "perfil",
			perfilDefaultPhoto: "../assets/images/default-user-icon.png",
			perfilSidebarDropdown: false,
            credito:0,
		};
	},
	computed: {
		userFoto() {
            this.formantUrlShared();
			return this.user.public_id
				? this.$cloudinary.url(this.user.public_id, {
						width: 600,
						height: 600,
						gravity: "faces",
						crop: "fill"
				  })
				: "";
		},
		didLoadUser() {
			return this.site.didLoadUser;
		},
        ...mapState(["portal", "user", "site", "isPortalReady"]),
        ...mapGetters([ "userId"])
	},
	watch: {
		didLoadUser(val, old) {
			if (val) {
				if (this.user.id == 0) {
					// No está logueado.
					this.$router.push({ name: "home" });
                }


			}
        }
        ,
        userId(val, old) {
			if (val != 0 && old == 0) {
				console.log("cargando referidos", val);
				this.formantUrlShared();
			}
        }

	},
	methods: {
		formatCurrency(amount) {
			return numeral(amount).format("$0,0");
		},
		setActiveTab(tab) {
			this.activeTab = tab;
			this.perfilSidebarDropdown = false;
		},
		updatePhoto(file) {
			this.$store
				.dispatch("updateUserPhoto", file)
				.then(response => {
					// Actualizar foto de usuario
					let data = response.data.data;
					this.$store.commit("setUserInfo", {
						public_id: data.public_id,
						foto: data.foto
					});
				})
				.catch(error => console.log);
		},
		toggleSidebarMenu() {
			this.perfilSidebarDropdown = !this.perfilSidebarDropdown;
        },
        formantUrlShared() {
             if(this.userId > 0 && this.user.referidos){

                    this.credito = this.user.referidos.credito;

                    this.tabs.forEach(val => {
                            if (val.name == "referidos"){
                                val.title = "Mis Referidos (Crédito : "+this.formatCurrency(this.credito)+")";
                            }
                    });

            }
        }
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			console.log({ vm });
			if (vm.site.didLoadUser && vm.user.id == 0) {
				// No está logueado.
				vm.$router.push({ name: "home" });
            }

		});
	},
	beforeRouteUpdate(to, from, next) {
		if (this.site.didLoadUser && this.user.id == 0) {
			// No está logueado.
			this.$router.push({ name: "home" });
		} else next();
    }
};
</script>
